<p-dialog
  [header]="confirmConfig?.title || 'confirm' | translate"
  [visible]="true"
  [resizable]="false"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [closeIcon]="">
  <div class="confirm-content">
    @if (confirmConfig?.message) {
      <div class="confirm-message">
        {{ confirmConfig?.message | translate }}
      </div>
    }

    @if (confirmConfig?.options?.length > 0) {
      <div class="confirm-options p-field-radiobutton">
        @for (option of confirmConfig?.options; track option) {
          <div class="p-field-checkbox">
            <p-radioButton [value]="option" [inputId]="option.value" [(ngModel)]="selectedItem"> </p-radioButton>
            <label [for]="option.value">{{ option.label }}</label>
          </div>
        }
      </div>
    }
  </div>

  <ng-template #footer>
    <cap-button [label]="'general.no' | translate" styleClass="secondary" icon="fas fa-times" (click)="onReject()">
    </cap-button>

    <cap-button [label]="'general.yes' | translate" styleClass="primary" icon="fas fa-check" (click)="onAccept()">
    </cap-button>
  </ng-template>
</p-dialog>
